const API_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:4000';

export const verifyQRCodePassword = async (urlId: string, password: string) => {
  try {
    const response = await fetch(`${API_URL}/${urlId}/verify-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ password }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to verify password');
    }

    return response.json();
  } catch (error: any) {
    throw new Error(error.message || 'Failed to verify password');
  }
};

export const getQRCodeRedirect = async (urlId: string) => {
  try {
    const response = await fetch(`${API_URL}/${urlId}`);

    if (!response.ok) {
      if (response.status === 401) {
        const data = await response.json();
        return { requiresPassword: true, message: data.message };
      }
      const error = await response.json();
      throw new Error(error.error || 'Failed to get redirect URL');
    }

    return response.json();
  } catch (error: any) {
    throw new Error(error.message || 'Failed to get redirect URL');
  }
}; 